export default "__VITE_ASSET__LR_J4RMR__"